import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory } from './types';

export const creditPoolLowDescriptor = defineNotificationCategory('credit_pool_low', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/credits`,
  nonDisableable: true,
  pills: () => ['Credits'],
  audience: PERMISSIONS.EDIT_BILLING,
  scope: 'account',
  defaultChannels: ['email', 'in_app'],
});
